module.exports = __webpack_public_path__ + "static/media/select-sub-image.d201bf90.png";